import Cookies from 'js-cookie';

export const setAuthCookie = (token, expirationDate) => {
    const expiration = new Date(expirationDate);
    Cookies.set('shelfAuthToken', token, { expires: expiration, sameSite: 'strict' });
};

export const getAuthCookie = () => {
    const token = Cookies.get('shelfAuthToken');
    if (!token) return 'expired';
    return token;
};

export const removeAuthCookie = () => {
    Cookies.remove('shelfAuthToken');
};
